import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import PropTypes from 'prop-types';

import palette from './palette';
import typography from './typography';
import shadows, { customShadows } from './shadows';
import componentsOverride from './overrides';

export default function ThemeProvider({ children }) {
  const themeOptions = {
    palette,
    shape: { borderRadius: 8 },
    typography,
    shadows,
    customShadows,
  };

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};
